<template>
  <div class="suppliesManagePage" v-if="!this.showLoad">
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="suppInput.materialName"
        clearable
        :required="editType"
        label="名称："
        :placeholder="editType ? '请输入...  ' : ''"
        :readonly="!editType"
        rows="1"
        autosize
        type="textarea"
        class="ggInput materialName"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="suppInput.materialType"
        :required="editType"
        label="类型："
        :placeholder="editType ? '请输入...  ' : ''"
        :readonly="!editType"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="suppInput.materialNatureName"
        :required="editType"
        readonly
        label="属性："
        :placeholder="editType ? '请选择' : ''"
        :is-link="editType"
        @click="changeMaterialNature"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group
      class="baseNone baseSalary"
      v-if="suppInput.materialNature == 'yhp'"
    >
      <van-field
        v-model="suppInput.materialChildTypeName"
        :required="editType"
        readonly
        label="易耗品子属性："
        :placeholder="editType ? '请选择' : ''"
        :is-link="editType"
        @click="changeChildType"
        class="ggInput"
      />
      <van-field
        v-model="suppInput.postNames"
        readonly
        :is-link="editType"
        type="textarea"
        rows="1"
        autosize
        label="适用岗位："
        :placeholder="editType ? '请选择' : ''"
        class="ggInput"
        @click="changeChildPost()"
      />
      <van-field
        v-model="suppInput.userNames"
        type="textarea"
        readonly
        :is-link="editType"
        rows="1"
        autosize
        label="适用人员："
        :placeholder="editType ? '请选择' : ''"
        class="ggInput"
        @click="changeChildUser()"
      />
      <van-field
        v-model="suppInput.deptNames"
        type="textarea"
        readonly
        :is-link="editType"
        rows="1"
        autosize
        label="适用部门："
        :placeholder="editType ? '请选择' : ''"
        class="ggInput"
        @click="changeChildDept()"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="suppInput.code"
        clearable
        :required="editType"
        label="编号："
        :placeholder="editType ? '请输入...  ' : ''"
        :readonly="!editType"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary moreText">
      <van-field
        v-model="suppInput.total"
        clearable
        :required="editType"
        label="入库数量："
        :placeholder="editType ? '请输入...  ' : ''"
        readonly
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary moreText">
      <van-field
        v-model="suppInput.unit"
        clearable
        :required="editType"
        label="单位："
        :placeholder="editType ? '请输入...  ' : ''"
        :readonly="!editType"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary moreText">
      <van-field
        v-model="suppInput.price"
        clearable
        :required="editType"
        label="单价（元）："
        :placeholder="editType ? '请输入...  ' : ''"
        :readonly="!editType"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="suppInput.warningLimit"
        clearable
        label="警戒值："
        :placeholder="editType ? '请输入...  ' : ''"
        :readonly="!editType"
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary beizhu">
      <van-field
        v-model="suppInput.remarks"
        label="备注："
        rows="1"
        autosize
        type="textarea"
        :readonly="!editType"
        :placeholder="editType ? '请输入...  ' : ''"
      />
    </van-cell-group>

    <div class="btnBox" v-if="mode == 'add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput('add')"
        >提交</van-button
      >
    </div>
    <!-- 编辑状态下 -->

    <div class="btnBox editBtnbox clearfix" v-if="mode == 'edit' && editType">
      <van-row class="dis_flex justy_space btnGroup">
        <van-col span="10">
          <van-button
            type="danger"
            :loading="btnLoading"
            :loading-text="loadingText"
            @click="delApply"
            >删除</van-button
          >
        </van-col>
        <van-col span="4"></van-col>
        <van-col span="10">
          <van-button
            type="info"
            :loading="btnLoading"
            :loading-text="loadingText"
            @click="checkInput('edit')"
            >保存</van-button
          >
        </van-col>
      </van-row>
    </div>

    <!-- 物资性质,属性弹框 -->
    <van-popup v-model="showMaterialNature" position="bottom">
      <van-picker
        show-toolbar
        :columns="materialNatureData"
        value-key="name"
        @cancel="showMaterialNature = false"
        @confirm="saveMaterialNature"
      />
    </van-popup>
    <!-- 易耗品子属性选择 -->
    <van-popup v-model="showChildTypePicker" position="bottom" class="guardBox">
      <van-picker
        title="易耗品子属性"
        show-toolbar
        value-key="label"
        :columns="materialChildTypeData"
        @confirm="saveNatureChildType"
        @cancel="showChildTypePicker = false"
      />
    </van-popup>
    <!--  适用岗位管理 -->
    <van-popup v-model="showChildPostPicker" position="bottom" class="roleBox">
      <post-view :postIds="suppInput.post" @setPostItems="setPost"></post-view>
    </van-popup>
    <!--  适用人员 -->
    <van-popup v-model="showChildUserPicker" position="bottom" class="roleBox">
      <retinue-view
        :retinueUids="suppInput.user"
        @setReview="setUsers"
      ></retinue-view>
    </van-popup>
    <!--  适用部门 -->
    <van-popup v-model="showChildDeptPicker" position="bottom" class="roleBox">
      <dept-view :deptIds="suppInput.dept" @setDeptData="setDepts"></dept-view>
    </van-popup>
  </div>
</template>
<script>
/*eslint-disable*/

import { mapState, mapMutations } from "vuex";
import { dateFormat, getDictList } from "@/utils/common";
import { getDeviceType, closePage } from "@/common/getDeviceType/getDeviceType";
const fileView = () => import("@/components/common/fileView");
const postView = () => import("@/components/common/PostList");
const deptView = () => import("@/components/common/deptList");
const retinueView = () => import("@/components/businessTripMould/retinueView");
export default {
  name: "suppliesManage",
  components: {
    postView,
    retinueView,
    deptView,
  },
  data() {
    return {
      mode: "add",
      editType: false, //false不可编辑
      suppInput: {
        id: "",
        materialName: "", //名称
        materialType: "", //物资类型名称
        materialNature: "", //物资性质,属性
        materialNatureName: "", //物资性质名称
        materialChildTypeName: "", //易耗品子类型名称
        materialChildType: "", //易耗品子类型
        dept: [],
        deptNames: "",
        post: [],
        postNames: "",
        user: [],
        userNames: "",
        code: "", //物资编号
        total: "", //入库数量
        unit: "", //单位
        price: "", //单价
        warningLimit: "", //警戒值
        enable: true, //默认是开启
        remarks: "", //备注
        baseAnnexes: [], //附件
      },
      materialChildDeptData: [], //易耗品适用岗位list
      showChildTypePicker: false, //易耗品子类型弹框
      showChildPostPicker: false, //易耗品适用岗位
      materialItemPostIndex: 0,
      showChildDeptPicker: false, //易耗品适用部门
      materialItemDeptIndex: 0,
      showChildUserPicker: false, //易耗品适用人员
      materialItemUserIndex: 0,
      showChildTypePicker: false, //易耗品子类型弹框
      showMaterialType: false, //物资类型控件
      materialTypeData: [], //物资类型数据
      //易耗品子类型
      materialChildTypeData: [
        {
          value: "zdyp",
          label: "招待用品",
        },
        {
          value: "bgyp",
          label: "办公用品",
        },
      ],
      showMaterialNature: false, //物资性质,属性控件
      materialNatureData: this.materialNatureData, //物资性质,属性数据
      verifyPageType: false, //审批弹框,默认不显示
      verifyPageText: "",
      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      clientType: getDeviceType(), //手机类型
    };
  },
  async mounted() {
    window.editPage = this.editPage; //编辑页面
    this.materialTypeData = await getDictList("wuzileixing");
    this.$nextTick(function () {
      this.mode = this.$route.query.commonType; // add:新增 edit:编辑/查看
      this.commonId = this.$route.query.commonId; //详情Id

      this.initPage();
    });
  },
  methods: {
    //添加一个状态控件，默认开启
    ...mapMutations(["setShowLoad", "setAppData"]),
    editPage() {
      this.editType = true;
    },
    initPage() {
      this.setShowLoad(false); //加载状态，默认为true加载
      if (this.mode == "add") {
        this.editType = true;
      } else {
        this.getDetails();
      }
    },
    /*获取详情*/
    getDetails() {
      let _this = this;
      _this.$api.material.materialManage
        .details(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.suppInput = res.data;
            if (_this.suppInput.remarks == null) {
              _this.$set(_this.suppInput, "remarks", "");
            }
            _this.suppInput.materialNatureName = _this.suppInput.materialNature
              ? _this.suppInput.materialNature == "yhp"
                ? "易耗品"
                : "固定资产"
              : "";
            _this.suppInput.materialChildTypeName = _this.suppInput
              .materialChildType
              ? _this.suppInput.materialChildType == "zdyp"
                ? "招待用品"
                : "办公用品"
              : "";
            _this.suppInput.deptNames =
              _this.suppInput.deptNames == null
                ? ""
                : _this.suppInput.deptNames;
            _this.suppInput.postNames =
              _this.suppInput.postNames == null
                ? ""
                : _this.suppInput.postNames;
            _this.suppInput.userNames =
              _this.suppInput.userNames == null
                ? ""
                : _this.suppInput.userNames;
            if (_this.mode == "edit" && !_this.suppInput.enable) {
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，稍后重试");
        });
    },

    /*物资性质,属性数据*/
    changeMaterialNature() {
      if (this.editType) {
        this.showMaterialNature = true;
      }
    },
    // 易耗品子属性
    changeChildType() {
      if (this.editType) {
        this.showChildTypePicker = true;
      }
    },
    saveMaterialNature(data) {
      this.showMaterialNature = false;
      this.suppInput.materialNature = data.value;
      this.suppInput.materialNatureName = data.name;
    },
    saveNatureChildType(data) {
      //保存易耗品子属性
      this.showChildTypePicker = false;
      this.suppInput.materialChildType = data.value;
      this.suppInput.materialChildTypeName = data.label;
    },
    changeChildPost() {
      //选择适用岗位
      if (this.editType) {
        this.showChildPostPicker = true;
      }
    },
    setPost(data) {
      console.log(data);
      if (data != "") {
        this.$set(this.suppInput, "post", data.id);
        this.$set(this.suppInput, "postNames", data.name);
      }
      this.showChildPostPicker = false;
    },
    changeChildDept() {
      //选择适用部门
      if (this.editType) {
        this.showChildDeptPicker = true;
      }
    },
    setDepts(data) {
      if (data != "") {
        console.log(data);
        this.$set(this.suppInput, "dept", data.ids);
        this.$set(this.suppInput, "deptNames", data.names);
      }
      this.showChildDeptPicker = false;
    },
    changeChildUser() {
      //选择使用人员
      if (this.editType) {
        this.showChildUserPicker = true;
      }
    },
    setUsers(data) {
      if (data != "") {
        this.$set(this.suppInput, "user", data.ids);
        this.$set(this.suppInput, "userNames", data.names);
      }
      this.showChildUserPicker = false;
    },
    /*提交表单*/
    checkInput(msg) {
      let _this = this;
      console.log(JSON.stringify(_this.suppInput));
      if (
        _this.suppInput.materialType &&
        _this.suppInput.materialNature &&
        _this.suppInput.code &&
        _this.suppInput.total &&
        _this.suppInput.unit &&
        _this.suppInput.price
      ) {
        if (
          _this.suppInput.materialNature == "yhp" &&
          !_this.suppInput.materialChildType
        ) {
          _this.$toast("带星号为必填，不能为空");
          return false;
        }

        _this.mode = msg;
        _this.saveAll();
      } else {
        _this.$toast("带星号为必填，不能为空");
      }
    },

    /*保存接口*/
    saveAll() {
      let _this = this;
      _this.btnLoading = true;
      _this.$api.material.materialManage
        .save("edit", _this.suppInput)
        .then((res) => {
          if (res.code == "1" && res.success == true) {
            let text = this.mode == "add" ? "添加成功" : "编辑成功";
            closePage(text);
          } else {
            _this.$toast(res.msg);
          }
          _this.btnLoading = false;
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
          _this.btnLoading = false;
        });
    },
    /*删除*/
    delApply() {
      let _this = this;
      _this.$dialog
        .confirm({
          title: "确认删除",
          message: "您确认要删除当前信息？",
        })
        .then(() => {
          _this.btnLoading = true;
          _this.$api.material.materialManage
            .delete(_this.suppInput.id)
            .then((res) => {
              if (res.code == "1" && res.data == true) {
                let text = "删除操作成功";
                closePage(text);
              } else {
                _this.$toast(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch((err) => {
              _this.$toast("网络失败，请稍后重试");
              _this.btnLoading = false;
            });
        });
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
};
</script>
<style lang="less">
.suppliesManagePage {
  .ggInput {
    .van-cell__title {
      width: 200px;
    }
  }
  .materialName.ggInput{
     .van-cell__title {
      width: 100px;
    }
  }
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  padding-top: 10px;
  overflow-y: scroll;
  padding-bottom: 70px;
  .roleBox {
    width: 100%;
    height: 100%;
    padding-top: 15px;
    // overflow-y: initial;
  }
  h4 {
    position: relative;
    border-bottom: 1px solid #e0e0e0;
    line-height: 45px;
    padding: 0 20px;
    font-weight: 700;
    color: #2581d6;
    font-size: 15px;
    z-index: 10;
    background-color: #fff;
  }
  h4:before {
    content: "";
    position: absolute;
    width: 5px;
    height: 25px;
    background: #2581d6;
    top: 10px;
    left: 10px;
    bottom: 5px;
  }
  .baseNone::after {
    content: none;
  }
  .baseNone {
    .ggInput {
      border-bottom: 1px solid #ebedf0;
    }
  }
  .baseNone {
    .van-cell::after {
      content: none;
    }
  }
  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }

  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin-top: 10px;
  }
  //审批操作样式
}
</style>